module.exports = __webpack_public_path__ + "bafb105baeb22d965c70fe52ba6b49d9.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-400.woff
// module id = 664
// module chunks = 0